/**
 * Product media gallery — Swiper (image principale synchronisée aux thumbnails).
 * Initialise chaque conteneur [data-pm] (un par panneau produit).
 */
(function () {
  function whenSwiper(cb) {
    if (window.Swiper) return cb();
    var n = 0;
    var t = setInterval(function () {
      if (window.Swiper || n++ > 100) { clearInterval(t); if (window.Swiper) cb(); }
    }, 50);
  }

  function initOne(root) {
    if (root.__pmInit) return;
    root.__pmInit = true;

    var mainEl = root.querySelector('[data-pm-main]');
    var thumbsEl = root.querySelector('[data-pm-thumbs]');
    if (!mainEl) return;

    var thumbs = null;
    if (thumbsEl) {
      thumbs = new window.Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 6,
        watchSlidesProgress: true,
        freeMode: true,
        slideToClickedSlide: true,
      });
    }

    new window.Swiper(mainEl, {
      slidesPerView: 1,
      speed: 500,
      thumbs: thumbs ? { swiper: thumbs } : undefined,
      navigation: {
        prevEl: root.querySelector('[data-pm-prev]'),
        nextEl: root.querySelector('[data-pm-next]'),
      },
    });
  }

  function init() {
    document.querySelectorAll('[data-pm]').forEach(initOne);
  }

  whenSwiper(function () {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  });
})();
